import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import HowItWorks from "./components/HowItWorks";
import TrackRecord from "./components/TrackRecord";
import Steps from "./components/Steps";
import Accounts from "./components/Accounts";
import Calculator from "./components/Calculator";
import GrossToNet from "./components/GrossToNet";
import Risk from "./components/Risk";
import Faq from "./components/Faq";
import ProfitSharing from "./components/ProfitSharing";
import RequestInfo from "./components/RequestInfo";
import Admin from "./pages/Admin";

function Landing() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Marquee />
      <HowItWorks />
      <TrackRecord />
      <Steps />
      <Accounts />
      <Calculator />
      <GrossToNet />
      <Risk />
      <Faq />
      <ProfitSharing />
      <RequestInfo />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
